var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClassificationResult',{class:_vm.$style.indicator,attrs:{"result":_vm.indicator}},[_c('IxRes',[_vm._v("dlgCert.headers."+_vm._s(_vm.pillar)+"_"+_vm._s(_vm.indicator.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }